import { Box, Card, Heading, Icon } from '@zillow/constellation-10';
import { IconMegaphoneFilled } from '@zillow/constellation-icons';

import PremiumTag from '../PremiumTag';

import { wizardTipCardRecipe } from './styles';

import type React from 'react';

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  header?: string | null;
  isPremiumTip?: boolean;
};

const WizardTipCard = ({
  icon = <IconMegaphoneFilled />,
  children = null,
  header = null,
  isPremiumTip = false,
}: Props) => (
  <Card.Root tone="neutral" elevated={false} css={wizardTipCardRecipe.raw({ isPremium: isPremiumTip })}>
    <Card.Body>
      <Box css={{ marginBottom: '400' }}>
        {isPremiumTip ? <PremiumTag /> : <Icon render={icon} size="xl" css={{ color: 'icon.subtle' }} />}
      </Box>

      {header && (
        <Box css={{ marginBottom: '400' }}>
          <Heading level={6} id="tip-title">
            {header}
          </Heading>
        </Box>
      )}

      {children}
    </Card.Body>
  </Card.Root>
);

export { WizardTipCard };
